import type { ClaimBarFieldConfiguration } from '~/components/ClaimPage/types';

type ClaimBarFieldKey = ClaimBarFieldConfiguration['field_key'];

/**
 * The availability is checked internally in the relevant claim bar components as well
 * The util should be updated when internal checks are updated (on the organization level)
 * */
export const isClaimBarFieldAvailableForOrganization = (
  field_key: ClaimBarFieldKey,
  isClaimSearchEnabled: boolean
): boolean => {
  if (field_key === 'claim_alerts') {
    return isClaimSearchEnabled;
  }
  return true;
};
